const Style = {
    title: 'mb-2 flex items-center gap-2 text-sm font-semibold text-text-primary',
    container: 'flex flex-wrap gap-3',
    // Compact: a row of small squares that survives being in a fixed band.
    containerCompact: 'flex-nowrap gap-2 overflow-x-auto pb-1',
    // Grid: fluid squares for the rail card.
    containerGrid: 'grid grid-cols-3 gap-2',
    link: `group relative block w-full max-w-[200px] overflow-hidden rounded-lg border border-border
        bg-muted/20 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring`,
    linkCompact: 'h-16 w-16 max-w-none shrink-0',
    linkGrid: 'max-w-none',
    img: 'aspect-[4/3] w-full object-cover',
    imgCompact: 'aspect-square',
    overlay: `absolute inset-0 flex items-center justify-center bg-black/0 opacity-0 transition-all
        group-hover:bg-black/40 group-hover:opacity-100`,
    fallback: `flex aspect-[4/3] w-full max-w-[200px] flex-col items-center justify-center gap-2
        rounded-lg border border-border bg-muted/25 px-3 py-4 text-center`,
    fallbackCompact: 'aspect-square h-16 w-16 max-w-none shrink-0 px-0 py-0',
    fallbackGrid: 'aspect-square max-w-none px-0 py-0',
};

export default Style;
